// Central language + locale configuration for BooklyAI.
// English is the default and fallback for every namespace.
//
// NOTE ON CURRENCY: BooklyAI charges everything in USD (see server-side price re-derivation
// in POST /api/bookings). The `currency` field below is retained only for future FX-aware
// pricing; today the UI always renders USD, but formatted per the user's locale (so a French
// visitor sees "99,00 $US" instead of "$99.00"). This keeps the displayed amount aligned
// with what Stripe actually charges.

export const LANGUAGES = [
  { code: "en", label: "English",   locale: "en-US", currency: "USD", dir: "ltr" },
  { code: "es", label: "Español",   locale: "es-ES", currency: "USD", dir: "ltr" },
  { code: "fr", label: "Français",  locale: "fr-FR", currency: "USD", dir: "ltr" },
  { code: "de", label: "Deutsch",   locale: "de-DE", currency: "USD", dir: "ltr" },
  { code: "pt", label: "Português", locale: "pt-PT", currency: "USD", dir: "ltr" },
  { code: "it", label: "Italiano",  locale: "it-IT", currency: "USD", dir: "ltr" },
  { code: "hi", label: "हिन्दी",      locale: "hi-IN", currency: "USD", dir: "ltr" },
  { code: "ar", label: "العربية",    locale: "ar-SA", currency: "USD", dir: "rtl" },
  { code: "ur", label: "اردو",       locale: "ur-PK", currency: "USD", dir: "rtl" },
  { code: "zh", label: "中文",       locale: "zh-CN", currency: "USD", dir: "ltr" },
  { code: "ja", label: "日本語",      locale: "ja-JP", currency: "USD", dir: "ltr" },
  { code: "tr", label: "Türkçe",    locale: "tr-TR", currency: "USD", dir: "ltr" },
  { code: "ru", label: "Русский",   locale: "ru-RU", currency: "USD", dir: "ltr" },
];

export const LANGUAGE_MAP = Object.fromEntries(LANGUAGES.map(l => [l.code, l]));

export const RTL_LANGUAGES = LANGUAGES.filter(l => l.dir === "rtl").map(l => l.code);

export const DEFAULT_LANGUAGE = "en";

// LocalStorage keys — customer & owner keep independent preferences.
export const STORAGE_KEYS = {
  customer: "bookly_lang_customer",
  owner: "bookly_lang_owner",
};

// Routes that belong to the "owner" scope (their own language preference).
export const OWNER_ROUTE_PREFIXES = ["/login", "/dashboard"];

export function detectScope(pathname) {
  return OWNER_ROUTE_PREFIXES.some(p => pathname === p || pathname.startsWith(p + "/"))
    ? "owner"
    : "customer";
}
